import axios from 'axios'
import cookies from 'vue-cookies'

export default {
  namespaced: true,
  state: {
    freeDocumentsGrid: [],
    freeDocumentsGroupsShow: [],
    pageData: null,
    uploadDocumentsProgress: 0,
  },
  mutations: {
    setFreeDocumentsGrid(state, payload) {
      state.freeDocumentsGrid = payload
    },
    setFreeDocumentsShow(state, payload) {
      state.freeDocumentsShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setUploadDocumentsProgress(state, payload) {
      state.uploadDocumentsProgress = payload
    },
  },
  getters: {
    freeDocumentsGrid: (state) => state.freeDocumentsGrid,
    freeDocumentsShow: (state) => state.freeDocumentsShow,
    uploadDocumentsProgress: (state) => state.uploadDocumentsProgress,
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onFreeDocumentsGrid({ commit, rootState }, { type, limit, page, id, sort }) {
      commit('setLoadingAnimation', true, { root: true })
      let url = rootState.apiDomain + `/api/${type ? type : 'admin'}/work/free-document/`
      if (type === 'admin') {
        url =
          url + 'grid?limit=' + limit + '&page=' + page + '&filter[]=free_document_group_id:' + id
        if (sort) {
          url = url + '&order[]=' + sort.param + ':' + sort.value
        } else {
          url = url + '&order[]=name:asc'
        }
      } else {
        url = url + 'groups/' + id
        if (sort) {
          url = url + '?order[]=' + sort.param + ':' + sort.value
        } else {
          url = url + '?order[]=name:asc'
        }
      }
      console.log('onFreeDocumentsGrid', url)
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setFreeDocumentsGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onFreeDocumentsGridUpdate({ commit, rootState }, { type, limit, page, id }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            `/api/${type ? type : 'admin'}/work/free-document/grid?limit=` +
            limit +
            '&page=' +
            page +
            '&filter[]=free_document_group_id:' +
            id +
            '&order[]=name:asc',
          limit: limit,
          page: page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setFreeDocumentsGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onFreeDocumentsShow({ commit, rootState }, id) {
      commit('setLoadingAnimation', true, { root: true })
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/free-document/' + id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setFreeDocumentsShow', resp.data.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onFreeDocumentsCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/free-document',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onFreeDocumentsUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/free-document',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onFreeDocumentsDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/free-document/' + id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onFreeDocumentsUploadFiles({ commit, rootState }, { data }) {
      return new Promise((resolve, reject) => {
        let progress = 0
        axios({
          url: rootState.apiDomain + '/api/uploadfile',
          data: data,
          method: 'POST',
          onUploadProgress: (e) => {
            progress = Math.round((e.loaded * 98) / e.total)
            commit('setUploadDocumentsProgress', progress)
          },
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
